import { ManufacturerType } from 'models/ManufacturerType';

export class Manufacturer {
    id: number;
    name: string;
    manufacturerType: ManufacturerType;
    archivedDate?: Date;

    constructor(
        id: number,
        name: string,
        manufacturerType: ManufacturerType,
        archivedDate?: Date
    ) {
        this.id = id;
        this.name = name;
        this.manufacturerType = manufacturerType;
        this.archivedDate = archivedDate;
    }

    static empty(): Manufacturer {
        return { id: 0, name: '', manufacturerType: ManufacturerType.empty() };
    }
}
